{
    "CustomNameLabel": "Name:",
    "CustomWidthLabel": "Width (0 - 100):",
    "NAME": "CustomSettings",
    "CustomSettings_SectionHeader": "Custom Settings"
}